"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Dropdown_1 = tslib_1.__importDefault(require("../../../Dropdown"));
var PopupContainerProvider_1 = require("../../../PopupContainerProvider");
var utils_1 = require("../../../utils");
var Header_1 = require("../../Header");
var SelectFilter_1 = tslib_1.__importStar(require("../SelectFilter"));
function FilterIcon(_a) {
    var column = _a.column;
    var _b = react_1.useContext(Header_1.HeaderContext), headerElement = _b.headerElement, headerPrefix = _b.headerPrefix;
    var prefix = utils_1.concat(headerPrefix, 'filter');
    var filteredCls = utils_1.concat(prefix, 'filtered');
    var ref = react_1.useRef(null);
    var _c = react_1.useState([0, 0]), offset = _c[0], setOffset = _c[1];
    var _d = react_1.useState(false), dropdownVisible = _d[0], setDropdownVisible = _d[1];
    react_1.useEffect(function () {
        if (ref.current && headerElement) {
            var offsetX = headerElement.getBoundingClientRect().left
                - ref.current.getBoundingClientRect().left;
            var offsetY = headerElement.getBoundingClientRect().bottom
                - ref.current.getBoundingClientRect().bottom;
            setOffset([offsetX, offsetY]);
        }
    }, [headerElement]);
    // TODO 支持 Search
    var icon = react_1.default.createElement(SelectFilter_1.Icon, null);
    var overlay = (react_1.default.createElement(SelectFilter_1.default, { key: column.id, prefix: prefix, column: column, onClose: function () { return setDropdownVisible(false); } }));
    return (
    // 实现 icon 高亮的时候，考虑把 th 作为 container
    react_1.default.createElement(PopupContainerProvider_1.PopupContainerProvider, { containerRef: ref },
        react_1.default.createElement(Dropdown_1.default, { visible: dropdownVisible, align: { offset: offset }, trigger: "click", onVisibleChange: setDropdownVisible, overlay: overlay },
            react_1.default.createElement("div", { className: classnames_1.default(prefix, dropdownVisible && filteredCls), ref: ref }, icon))));
}
exports.default = FilterIcon;
//# sourceMappingURL=index.js.map